<template>
  <main class="main" id="main">
    <div class="top_line">
      <div class="container work_box">
        <h1 class="work">Доставка бутилированной воды 19 л на дом и в офис</h1>
      </div>
    </div>
    <section class="section s-about_franchise">
      <div class="container">
        <div class="description_box">
          <div class="item">
            <h2 style="margin-top:2%;">В чем преимущество бутилированной воды?</h2>
            <p style="margin-top:2%;">Бутилированная вода отличается чистотой своей продукции. В ней нет ароматизаторов, растительного экстракта и эссенции. Делится она на несколько видов:</p>
            <p>&nbsp;</p>
            <ul>
              <li>Артезианская(добывается в артезианских скважинах)</li>
              <li>Питьевая (для человеческих нужд.В ней нет добавок, ароматизаторов и других химических средств)</li>
              <li>Минеральная (содержащая большое количество растворенных солей от 0,25 г/л)</li>
              <li>Очищенная (дополнительно дистиллированная вода)</li>
              <li>Газированная (содержащая одно и то же количество углекислого газа до и после обработки)</li>
              <li>Ключевая (добывается из подземных родников)</li>
              <li>Колодезная (добывается из колодца или специально построенной скважины)</li>
            </ul>
            <p>&nbsp;</p>
            <center><img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/global/articles/voda.jpg" alt="Доставка воды"  width="640" /></center>
            <h2 style="margin-top:2%;">Доставка лучших фирм на дом и в офис</h2>
            <p style="margin-top:2%;">- «Легенда гор Архыз»</p>
            <p style="margin-top:2%;">Чистейшая вода, которую добывают в ущельях кавказских ледников. Неповторимый источник энергии. Оснащает наше тело полезными горными солями и минералами.  Без нее невозможно поддержание пластического и энергетического обмена в организме.</p>
            <p style="margin-top:2%;">- «Шишкин лес»</p>
            <p style="margin-top:2%;">Вода добывается в Подмосковье из водоносного подземного горизонта. Каждая капля проходит специальную обработку опытными специалистами. И все равно вода сохраняет тот неповторимый вкус, благодаря которому мы чувствуем неуловимую связь с природой.</p>
            <p style="margin-top:2%;">- «Волна Байкала»</p>
            <p style="margin-top:2%;">Вода, которую добывают из артезианских источников самого глубокого и чистого озера на планете. Озера Байкал! Она наполнена кислородом, а благодаря артезианской скважине  достигает известковых слоев почвы, тем самым впитывая множество полезных веществ.</p>
            <p style="margin-top:2%;">- «Ледниковая»</p>
            <p style="margin-top:2%;">С помощью минеральных солей и биологических микроэлементов вода способствует выведению шлаков и токсинов, поддержанию энергии и улучшению метаболизма. Несмотря на то, что перед упаковкой вода проходит специальную очистку (механическая фильтрация, угольная фильтрация, умягчение и т.д), специалисты позаботились о том, чтобы люди не были лишены полезных и восстанавливающих веществ, которые способствует поддержанию здоровья организма.</p>
            <p style="margin-top:2%;">Вся представленная выше продукция  имеет цену от 400 рублей за одну бутылку (19 л).  <router-link to="/product/34">Заказать  доставку воды</router-link> на дом или в офис по Москве и Московской области можно по телефону (495) 921-34-34 или онлайн, зарегистрировавшись на сайте. Каждая компания имеет специальный сертификат, который гарантирует высшее качество продукции!</p>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'voda'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/voda.vue